var stickyNav = ({
  selector = '.sticky',
  appliedClass = 'stick',
  scrollThreshold,
}) => {
  var nav = document.querySelector(selector);

  var top = () => {
    if (window.pageYOffset !== undefined) {
      return window.pageYOffset;
    }

    return (document.documentElement
      || document.body.parentNode
      || document.body)
      .scrollTop;
  };

  var updateStickyNavUI = (tp, threshold, el) => {
    if (tp >= threshold) {
      el.classList.add(appliedClass);
    } else {
      el.classList.remove(appliedClass);
    }
  };

  var scrollHandler = () => {
    var scrollTop = top();

    updateStickyNavUI(scrollTop, scrollThreshold, nav);
  };

  var scrollTop = top();

  updateStickyNavUI(scrollTop, scrollThreshold, nav);

  window.addEventListener('scroll', scrollHandler);
};

export default stickyNav;
